import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { useEffect, useState } from 'react'
import { FileImportDialog } from '../components/dialogs/FileImportDialog'
import { useTranslation } from 'react-i18next'
import { useTraderDiaryApi } from '../hooks/useTraderDiaryApi'
import { useDispatch } from 'react-redux'
import { ExpandMore } from '@mui/icons-material'
import useMobileWidth from '../hooks/useMobileWidth'
import { newThemeObject } from '../newTheme'
import { NewLayout } from '../components/newLayout/NewLayout'
import { AlertMessageConfirmation } from '../components/dialogs/AlertMessageConfirmation'
import { TraderDiaryTiles } from '../components/common/TraderDiaryTiles'
import { TraderDiaryTableTopBar } from '../components/TraderDiaryList/TraderDiaryTableTopBar'
import { TraderDiaryDisplay } from '../components/TraderDiaryList/TraderDiaryDisplay'
import { useTraderDiaryFilters } from '../hooks/useTraderDiaryFilters'
import { exportTraderDiariesAction } from '../redux/actions/traderDiaryActions'
import { TradeDiaryInputDialog } from '../components/dialogs/TraderDiaryInputDialog'

const useStyles = makeStyles(theme => ({
  orderDisplayTable: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(6),
    flexGrow: 1,
  },
  clientEssentials: {
    width: '25%',
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,
  },
  manIcon: {
    marginTop: theme.spacing(1),
  },
  clientPersonalInfoColumn: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(1),
  },
  test: {
    background: 'red',
    width: '200px',
    position: 'absolute',
    top: '20px',
    left: '-50px',
    opacity: '0.95',
    textAlign: 'center',
    lineHeight: '25px',
    fontSize: '16px',
    letterSpacing: '1px',
    color: '#f0f0f0',
    transform: 'rotate(-45deg)',
    paddingRight: '18px',
  },

  searchBar: {
    background: newThemeObject.palette.orderTable.searchBar.bg,
    padding: 0,
    borderRadius: '15px',
    margin: '20px 0',
    borderTop: 0,
    '&.Mui-expanded': {
      margin: '20px 0',
    },
    '&::before': {
      display: 'none',
    },
  },
  searchBarHeadText: {
    margin: 0,
    padding: 0,
  },
  searchBarHead: {
    padding: 0,
    margin: 0,
    dispay: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  accDetail: {
    padding: theme.spacing(2),
  },
}))

const ribon = process.env.REACT_APP_ENV_RIBBON

export const TraderDiary = () => {
  const classes = useStyles()
  const { getTraderDiaries, updateOrderDiary, exportTraderDiary } = useTraderDiaryApi()
  const { t } = useTranslation()
  const isMobile = useMobileWidth()
  const [filtersExpanded, setFiltersExpanded] = useState(isMobile)
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [traderDiariesToExport, setTraderDiariesToExport] = useState<number[]>([]);
  const dispatch = useDispatch();

  const [dateFrom, setDateFrom] = useState<Date>(new Date())
  const [dateTo, setDateTo] = useState<Date>(new Date())

  useEffect(() => {
    getTraderDiaries(dateFrom.toISOString(), dateTo.toISOString());
  }, [dateFrom, dateTo])

  const traderDiaryTableRows = useTraderDiaryFilters();

  useEffect(() => {
    isMobile ? setFiltersExpanded(false) : setFiltersExpanded(true)
  }, [isMobile])

  const handleChange = () => {
    setFiltersExpanded(!filtersExpanded)
  }

  const setTraderDiaryCheck = (traderDiaryId: number, valueDiary: boolean) => {
    updateOrderDiary(traderDiaryId, !valueDiary);
  }

  const setShowConfirmationDialog = (open: boolean) => {
    let tmp = [];
    for ( let i=0; i<traderDiaryTableRows.length; i++) {
      tmp.push(traderDiaryTableRows[i].traderDiaryId);
    }
    setTraderDiariesToExport(tmp)
    setShowConfirmation(open);
  }

  const handleConfirmation = () => {
    setShowConfirmation(false);
    exportTraderDiary(traderDiariesToExport);
    dispatch(exportTraderDiariesAction(traderDiariesToExport));
    setTraderDiariesToExport([]);
    getTraderDiaries(dateFrom.toISOString(), dateTo.toISOString());
  }

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
    setTraderDiariesToExport([]);
  }

  return (
    <NewLayout pageName={t('TRADER_DIARY')}>
      <TraderDiaryTiles />
      <Accordion elevation={0} className={classes.searchBar} expanded={filtersExpanded} onChange={handleChange}>
        <AccordionSummary expandIcon={<ExpandMore />} className={classes.searchBarHead}>
          <p className={classes.searchBarHeadText}>Filtry</p>
        </AccordionSummary>
        <AccordionDetails className={classes.accDetail}>
          <TraderDiaryTableTopBar
              dateFrom={dateFrom}
              setDateFrom={setDateFrom}
              dateTo={dateTo}
              setDateTo={setDateTo}
              setShowConfirmation={setShowConfirmationDialog}
          />
        </AccordionDetails>
      </Accordion>
      <TraderDiaryDisplay
        setTraderDiaryCheck={setTraderDiaryCheck}
      />
      <TradeDiaryInputDialog />
      <FileImportDialog />
      <AlertMessageConfirmation
        alertOpen={showConfirmation}
        onOk={handleConfirmation}
        onCancle={handleCloseConfirmation}
        alertText={t('INVESTMENT_DIARY_MESSAGE')}
      />
      
    </NewLayout>
  )
}
